import React from "react";
import AntdInput, { InputProps } from "antd/lib/input";
// import { withError, useTracker, TrackEventType, getTrackEventInfo } from '@fishx/tracker';
import { withError} from '@fishx/tracker';
const TextArea = AntdInput.TextArea;
const Search = AntdInput.Search;
const Group = AntdInput.Group;
const Password = AntdInput.Password;
interface RefInputProps extends InputProps {
  forwardedRef?: any;
}

interface FCInputProps extends React.FC<RefInputProps>{
     TextArea: typeof TextArea;
     Search: typeof Search;
     Group: typeof Group;
     Password: typeof Password;

}

export const Input: FCInputProps = (props) => {
  // const log = useTracker(Input.displayName);
  const {onClick, onKeyDown, onFocus, forwardedRef, ...other} = props;
  // let origValue;
  return (
    <AntdInput 
      {...other} 
      ref={forwardedRef}
      // onClick={(e) => {
      //   onClick && onClick(e);
      //   log(getTrackEventInfo(e, TrackEventType.CLICK, { origValue }));
      // }}
      // onKeyDown={(e) => {
      //   onKeyDown && onKeyDown(e);
      //   log(getTrackEventInfo(e.nativeEvent, TrackEventType.KEYDOWN, { origValue }));
      // }}
      // onFocus={(e) => {
      //   onFocus && onFocus(e);
      //   log(getTrackEventInfo(e, TrackEventType.FOCUS));
      //   origValue = e.target && e.target.value;
      // }}
    />
  );
};

Input.TextArea = TextArea;
Input.Search = Search;
Input.Group = Group;
Input.Password = Password;

Input.displayName = 'Input';
export default withError(Input, {forwardRef: true});



// WEBPACK FOOTER //
// ./src/components/input/index.tsx